import { opened01, getHeight01, opened02, getHeight02 } from './modules/accordion';
import { pageTop } from './modules/pageTop';
import { scrollmagic } from './modules/scrollmagic';
import { smooth } from './modules/smooth';

opened01();
opened02();
pageTop();
scrollmagic();
smooth();

window.addEventListener('load', function () {
  getHeight01();
  getHeight02();
});

window.addEventListener('resize', function () {
  getHeight01();
  getHeight02();
});
